import { render, staticRenderFns } from "./PressAlbumMain.vue?vue&type=template&id=49f7ee12&"
import script from "./PressAlbumMain.vue?vue&type=script&lang=js&"
export * from "./PressAlbumMain.vue?vue&type=script&lang=js&"
import style0 from "./PressAlbumMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f7ee12')) {
      api.createRecord('49f7ee12', component.options)
    } else {
      api.reload('49f7ee12', component.options)
    }
    module.hot.accept("./PressAlbumMain.vue?vue&type=template&id=49f7ee12&", function () {
      api.rerender('49f7ee12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/PressAlbumMain.vue"
export default component.exports